import { componentsRegistryService, RxBucket } from "cruzo";
import { ModalComponent, ModalConfig } from "cruzo/ui-components/modal";

export const appScope = new RxBucket(
  {
    profileModal: {
      config: ModalConfig({
        bodyContent: `<profile-component></profile-component>`,
        dependencies: new Set([
          "profile-component",
          "plus-icon",
          "button-group-component",
          "input-component",
          "spinner-component",
        ]),
      }),
    },
    subscriptionManageModal: {
      config: ModalConfig({
        bodyContent: `<subscription-manage-component></subscription-manage-component>`,
        dependencies: new Set(["subscription-manage-component"]),
      }),
    },
    grammarRuleModal: {
      config: ModalConfig({
        bodyContent: `<grammar-rule-modal-component></grammar-rule-modal-component>`,
        dependencies: new Set(["grammar-rule-modal-component", "close-icon"]),
      }),
    },
    proofreadPromptModal: {
      config: ModalConfig({
        bodyContent: `<proofread-prompt-modal-component></proofread-prompt-modal-component>`,
        dependencies: new Set(["proofread-prompt-modal-component"]),
      }),
    },
  }
);

componentsRegistryService.connectBucket(appScope);
